import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'datetimeFormatted',
    standalone: true
})
export class DatetimeFormatPipe implements PipeTransform {
    transform(date: string): string {
        return date ? DateTime.fromISO(date).toFormat("dd-MM-yyyy HH:mm") : "";
    }
}